export default __webpack_public_path__ + "linkedin-hrz-v1.svg";